var collapsible_list_pair_default = {
  "container": "zB2QI",
  "title": "IAz5E",
  "viewerContainer": "YMEiH",
  "titleContainer": "ZaeIZ",
  "expandIcon": "-zeyV",
  "dndIcon": "mGD42",
  "RTL": "X4vGi",
  "LTR": "sDdPw",
  "itemContainer": "Yma-3",
  "itemContainerViewer": "kEYoB",
  "mouseDown": "GJkWK",
  "innerEditor": "NYyjV",
  "item": "voKCH",
  "floatingAddPluginMenuWrapper": "_0LH4I",
  "childrenHidden": "h-wsR"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
